function useImageProps({
  alt = '',
  aspectRatio = 'auto',
  loading = 'eager',
  src
}) {
  return {
    alt,
    aspectRatio,
    loading,
    src
  }
}

export default useImageProps
